<app-title-section></app-title-section>
<div class="product-creation-wizard"  style="margin-left: 15px; margin-right: 15px">
    <div class="card flex-grow mb-0" style=" margin-left: 15px; margin-right: 15px; background-color: transparent">
        <div class="content-area-wrapper "  style="height: 87vh ;  gap: 16px">

    <div class="card" style="width: 400px">
        <app-layout-steps-client
                [steps]="steps"
                [currentStep]="currentStep"
                (goBack)="retour()"
                (stepSelected)="onTimelineStepSelected($event)">

        </app-layout-steps-client>
    </div>
            <!-- Content Right -->
            <div class="card content-right custom-scroll " style="overflow: auto;">

                <div class="content-wrapper p-0 content-right-r ">

                    <div class="card-body ">
                        <div class="wizard-content">
        <!-- Step 1: -->
        <div *ngIf="currentStep === 0 && mode === 'add'" class="step-form" >
            <div class="form-section rounded border-style d-flex" style="position: relative; flex-direction: column; padding-bottom: 50px;">
                <div style="display: flex; gap: 72px; width: 100%;">
                    <div class="option-card bordered" [ngClass]="{'selected': productData.type === 'Materiel', 'error-border': showStep1Error && productData.type !== 'Materiel'}" (click)="selectClientType('Materiel')">
                        <div class="card-content d-flex flex-column align-items-center justify-content-center">
                            <div class="icon-title-container d-flex align-items-center justify-content-center">
                                <i data-feather="arrow-up" size="24"></i>
                                <span>Emis</span>
                            </div>
                            <label class="container">
                                <input type="radio" id="materiel"
                                       name="productType"
                                       value="Materiel"
                                       [(ngModel)]="productData.type"
                                       (change)="validateStep1()"
                                       class="form-check-input">
                                <span class="checkmark"></span>
                            </label>

                        </div>
                    </div>
                    <div class="option-card bordered" [ngClass]="{'selected': productData.type === 'Service', 'error-border': showStep1Error && productData.type !== 'Service'}" (click)="selectClientType('Service')">
                        <div class="card-content d-flex flex-column align-items-center justify-content-center">
                            <div class="icon-title-container d-flex align-items-center justify-content-center">
                                <i data-feather="arrow-down" size="24"></i>
                                <span>Recu</span>
                            </div>

                            <label class="container">
                                <input type="radio"   id="service"
                                       name="productType"
                                       value="Service"
                                       [(ngModel)]="productData.type"
                                       (change)="validateStep1()"
                                       class="form-check-input ">
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </div>
                </div>
                <div *ngIf="showStep1Error" class="error-message" style="position: absolute; bottom: 15px; left: 0; width: 100%; margin-left: 39px">
                    <small class="text-danger">Veuillez sélectionner un type d'opération (Emis ou Recu)</small>
                </div>
            </div>
            <div class="d-flex justify-content-end mt-4">
                <button  (click)="handleStepCompletion(0)" class="btn btn-primary" style="height: 40px">
                    Continuer
                </button>
            </div>
        </div>

        <!-- Step 2: -->
        <div *ngIf="currentStep === 1" class="step-form">
            <form #step2Form="ngForm" (ngSubmit)="handleStepCompletion(1)">
                <div class="form-section rounded border-style d-flex mb-3"  style="position: relative; flex-direction: column; padding-bottom: 50px;">
                    <div style="display: flex; gap: 72px; width: 100%;">
                        <div class="option-card bordered" [ngClass]="{'selected': productData.typePaiementStep === 'Materiel', 'error-border': showStep2Error && productData.typePaiementStep !== 'Materiel'}" (click)="selectClientType('Materiel')">
                            <div class="card-content d-flex flex-column align-items-center justify-content-center">
                                <div class="icon-title-container d-flex align-items-center justify-content-center">
                                    <i data-feather="credit-card" size="24"></i>
                                    <span>Chèque</span>
                                </div>
                                <label class="container">
                                    <input type="radio" id="cheque"
                                           name="typePaiement"
                                           value="Materiel"
                                           [(ngModel)]="productData.typePaiementStep"
                                           (change)="validateStep2()"
                                           class="form-check-input">
                                    <span class="checkmark"></span>
                                </label>

                            </div>
                        </div>
                        <div class="option-card bordered" [ngClass]="{'selected': productData.typePaiementStep === 'Service', 'error-border': showStep2Error && productData.typePaiementStep !== 'Service'}" (click)="selectClientType('Service')">
                            <div class="card-content d-flex flex-column align-items-center justify-content-center">
                                <div class="icon-title-container d-flex align-items-center justify-content-center">
                                    <i data-feather="file-text" size="24"></i>
                                    <span>Traite</span>
                                </div>

                                <label class="container">
                                    <input type="radio"   id="traite"
                                           name="typePaiement"
                                           value="Service"
                                           [(ngModel)]="productData.typePaiementStep"
                                           (change)="validateStep2()"
                                           class="form-check-input ">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="showStep2Error" class="error-message" style="position: absolute; bottom: 15px; left: 0; width: 100%;margin-left: 39px">
                        <small class="text-danger">Veuillez sélectionner un moyen de paiement (Chèque ou Traite)</small>
                    </div>
                </div>

                <div class="d-flex justify-content-between mt-2">
                    <button (click)="goBack()" class="btn btn-retour"
                            style="background-color: rgba(19, 74, 211, 0.16) !important; color: rgba(19, 74, 211, 1);height: 40px">
                        <i class="bi bi-arrow-left me-1 "> </i> Retour
                    </button>
                    <button (click)="handleStepCompletion(1)" class="btn btn-primary">Continuer</button>
                </div>


            </form>
        </div>

        <!-- Step 3-->
        <div *ngIf="currentStep === 2" class="step-form">
            <form #step3Form="ngForm" (ngSubmit)="handleStepCompletion(2)">
                <!-- Phone Section -->
                <div class="form-section rounded border-style mb-3">

                        <div class="p-0">
                            <p class="titre1">Client</p>
                            <select
                                    class="form-control phone-input phone-type"
                                    [(ngModel)]="productData.client_id"
                                    name="client_id"
                                    id="client_id"
                                    (ngModelChange)="validateStep3()"
                                    [disabled]="isLoadingClients"
                            >
                                <option [value]="null">Choisissez le client</option>
                                <option *ngFor="let client of clients" [value]="client.id">
                                    {{ client.nom_prenom || 'Client sans nom' }}
                                </option>
                            </select>
                            <div *ngIf="isLoadingClients" class="text-muted mt-2">
                                <small>Chargement des clients...</small>
                            </div>
                        </div>

                </div>

                <div class="d-flex justify-content-between mt-2">
                    <button (click)="goBack()" class="btn btn-retour"
                            style="background-color: rgba(19, 74, 211, 0.16) !important; color: rgba(19, 74, 211, 1);height: 40px"
                    ><i class="bi bi-arrow-left me-1 "> </i> Retour
                    </button>
                    <button (click)="handleStepCompletion(2)" class="btn btn-primary">Continuer</button>
                </div>
            </form>
        </div>

        <!-- Step 4:  -->

        <div *ngIf="currentStep === 3" class="step-form">
            <form #step4Form="ngForm" (ngSubmit)="handleStepCompletion(3)">
                <div class="form-section rounded border-style" style="padding: 32px">
                    <div class="vertical-item" style=" padding-bottom: 24px">

                        <div class="titre1">Montant </div>
                        <div class="montant-input-container">
                            <button type="button" class="montant-button montant-button-decrement" (click)="decrementPaymentPeriod()">-</button>
                            <input
                                    type="number"
                                    class="montant-input"
                                    [(ngModel)]="productData.paymentPeriodValue"
                                    name="paymentPeriodValue"
                                    min="1"
                                    (ngModelChange)="validateStep4()"
                            />
                            <button type="button" class="montant-button montant-button-increment" (click)="incrementPaymentPeriod()">+</button>
                        </div>

                    </div>

                    <div class="items" style="padding-bottom: 24px">

                    <div class="option-cardSolde bordered solde-card" [ngClass]="{'selected': productData.solde_type === 'secondaire'}" (click)="selectClientType('Materiel')">
                        <div class="solde-content">
                            <div class="solde-header">
                                <label class="container solde-radio m-0">
                                    <input type="radio" id="solde_secondaire"
                                           name="soldeType"
                                           value="secondaire"
                                           [(ngModel)]="productData.solde_type"
                                           (change)="validateStep4()"
                                           class="form-check-input">
                                    <span class="checkmark"></span>
                                </label>
                                <span class="solde-label">Solde secondaire</span>
                            </div>
                            <div class="solde-amount-wrapper">
                                <span class="solde-amount" [ngClass]="{'selected-amount': productData.solde_type === 'secondaire'}">{{ soldeSecondaire }} TND</span>
                            </div>
                        </div>
                    </div>
                    <div class="option-cardSolde bordered solde-card" [ngClass]="{'selected': productData.solde_type === 'primaire'}" (click)="selectClientType('Service')">
                        <div class="solde-content">
                            <div class="solde-header">
                                <label class="container solde-radio m-0">
                                    <input type="radio" id="solde_primaire"
                                           name="soldeType"
                                           value="primaire"
                                           [(ngModel)]="productData.solde_type"
                                           (change)="validateStep4()"
                                           class="form-check-input">
                                    <span class="checkmark"></span>
                                </label>
                                <span class="solde-label">Solde primaire</span>
                            </div>
                            <div class="solde-amount-wrapper">
                                <span class="solde-amount" [ngClass]="{'selected-amount': productData.solde_type === 'primaire'}">{{ soldePrimaire }} TND</span>
                            </div>
                        </div>
                    </div>
                    </div>
                    <div style="padding-bottom: 24px">
                        <label class="form-label">Porteur</label>
                        <input
                                type="text"
                                class="form-control"
                                [(ngModel)]="productData.porteur"
                                name="porteur"
                                placeholder="Entrez le porteur"
                                (ngModelChange)="validateStep4()"
                        />
                    </div>
                    <div style="padding-bottom: 24px">
                        <p class="titre1">Banque</p>
                        <select
                                class="form-control phone-input phone-type"
                                [(ngModel)]="productData.banque_id"
                                name="banque_id"
                                id="banque_id"
                                (ngModelChange)="validateStep4()"
                                [disabled]="isLoadingBanques"
                        >
                            <option [value]="null">Choisissez la banque</option>
                            <option *ngFor="let banque of banques" [value]="banque.id">
                                {{ banque.nom || 'Banque sans nom' }}
                            </option>
                        </select>
                        <div *ngIf="isLoadingBanques" class="text-muted mt-2">
                            <small>Chargement des banques...</small>
                        </div>
                    </div>
                    <div style="padding-bottom: 24px">
                        <label class="form-label">Numéro de chèque/traite</label>
                        <input
                                type="text"
                                class="form-control"
                                [(ngModel)]="productData.numero_cheque"
                                name="numero_cheque"
                                placeholder="Entrez le numéro de chèque/traite"
                                (ngModelChange)="validateStep4()"
                        />
                    </div>


                </div>

                <div class="d-flex justify-content-between align-items-center mt-4">

                    <button
                            type="button"
                            class="btn btn-retour"
                            (click)="goBack()"
                            style="background-color: rgba(19, 74, 211, 0.16) !important; color: rgba(19, 74, 211, 1);height: 40px"
                    >
                        <i class="bi bi-arrow-left me-2"></i> Retour
                    </button>
                    <div class="buttonsep">
                        <button class="btn btn-outline-primary" (click)="quickAdd()">Ajout Rapide</button>
                        <button
                                type="button"
                                class="btn btn-primary"
                                (click)="handleStepCompletion(3)"

                        >
                            Continuer
                        </button>
                </div>

                </div>





            </form>
        </div>

        <!-- Step 5:  -->
        <div *ngIf="currentStep === 4" class="step-form">
            <form #step4Form="ngForm" (ngSubmit)="handleStepCompletion(4)">
                <div class="form-section rounded border-style" style="padding: 32px">

                    <div style="padding-bottom: 24px">
                        <label class="form-label">Date d’échéance</label>
                        <input
                                type="date"
                                class="form-control"
                                #dateEcheanceInput
                                [(ngModel)]="productData.date_echeance"
                                name="date_echeance"
                                placeholder="Choisissez la date d’échéance"
                                (ngModelChange)="validateStep5()"
                        />
                    </div>
                    <div style="padding-bottom: 24px">
                        <p class="titre1">Date de règlement</p>
                        <input
                                type="date"
                                class="form-control"
                                #dateReglementInput
                                [(ngModel)]="productData.date_reglement"
                                name="date_reglement"
                                placeholder="Choisissez la date de règlement"
                                (ngModelChange)="validateStep5()"
                        />
                    </div>
                    <div style="padding-bottom: 24px">
                        <label class="form-label">Note</label>
                        <textarea
                                [(ngModel)]="productData.note"
                                name="note"
                                class="form-control"
                                placeholder="Entrez une note"
                                (ngModelChange)="validateStep5()">


                             </textarea>
                    </div>


                </div>

                <div class="d-flex justify-content-between align-items-center mt-4">

                    <button
                            type="button"
                            class="btn btn-retour"
                            (click)="goBack()"
                            style="background-color: rgba(19, 74, 211, 0.16) !important; color: rgba(19, 74, 211, 1);height: 40px"
                    >
                        <i class="bi bi-arrow-left me-2"></i> Retour
                    </button>
                    <div class="d-flex gap-2">

                        <button
                                type="button"
                                class="btn btn-primary"
                                (click)="handleStepCompletion(4)"
                                style="margin-left: 24px;height: 40px"
                        >
                            Continuer
                        </button>
                    </div>

                </div>





            </form>
        </div>
        <!-- Step 6: Terminé -->
        <div *ngIf="currentStep === 5" class="step-form">
            <div class="text-center form-section rounded p-4 border-style">
                <div class="success-icon mb-2">
                    <img src="./../../../../assets/images/logo/check.jpg" alt="check" style="width: 80px; height: auto;">
                </div>
                <h3 class="mb-3" style="font-size: 18px;font-weight: 700;color: rgba(47, 43, 61, 0.9)">{{ mode === 'edit' ? 'Client mis à jour avec succès' : 'Chèque bancaire  ajouté avec succès !' }}</h3>
                <div class="d-flex justify-content-center " style="gap: 24px">
                    <button (click)="addNewCheque()" class="btn btn-outline-primary" style="margin-right: 6px;">Ajouter un autre chèque ou traite</button>
                    <button (click)="viewCheque()" class="btn btn-primary">Afficher les chèques et les traites</button>
                </div>
            </div>
        </div>
    </div>
                    </div>
                </div>
            </div>
</div>
    </div>

